<template>
    <div class="tr">
        <ListItem link="/upcoming-rentals">My Rentals & Listings</ListItem>
        <ListItem link="/account-info">Account Settings</ListItem>
        <ListItem @click="logoutClick()">Log Out</ListItem>
    </div>
</template>

<script>
import ListItem from '@/components/controls/ListItem.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        ListItem
    },
    methods: {
        ...mapMutations('users', ['updateCurrentUser']),
        logoutClick() {
            this.$router.push({ path: '/' });
            this.updateCurrentUser(null);
            this.$auth.logout({
                makeRequest: true
            });
        }
    }
};
</script>
